var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTerracedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 87,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "terraced-icon_svg__a",
    d: "M0 86h117.424V.755H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5F5C60",
    d: "M1.452 35.354v-1.367h114.71v1.367"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5F5C60",
    strokeWidth: 1.424,
    strokeLinejoin: "round",
    d: "M99.286 11.993h6.618V6.511h-6.618z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5F5C60",
    strokeWidth: 1.12,
    strokeLinejoin: "round",
    d: "M98.649 6.63h7.893V1.56h-7.893z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5F5C60",
    strokeWidth: 1.424,
    strokeLinejoin: "round",
    d: "M65.133 11.993h6.618V6.511h-6.618z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5F5C60",
    strokeWidth: 1.12,
    strokeLinejoin: "round",
    d: "M64.495 6.63h7.893V1.56h-7.893z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5F5C60",
    strokeWidth: 1.424,
    strokeLinejoin: "round",
    d: "M29.561 11.993h6.617V6.511h-6.617z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5F5C60",
    strokeWidth: 1.12,
    strokeLinejoin: "round",
    d: "M28.924 6.63h7.893V1.56h-7.893z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5F5C60",
    strokeWidth: 1.424,
    d: "M96.66 50.202h10.584M81.178 50.202h10.585M61.778 50.468h9.255M44.662 50.196l10.121-.021M24.158 50.494l10.121-.021M96.424 67.841h10.584M61.631 68.106h9.402M24.158 68.133l10.121-.02M8.853 50.196l10.122-.021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.251 57.895H34.37V46.36H24.251v11.536zm0 17.809H34.37V64.166H24.251v11.537zm-15.6-17.808H18.77V46.358H8.651v11.536zm0 22.305H18.77V64.168H8.651V80.2zm-4.02.226h35.111V37.108H4.631v43.319z",
    stroke: "#5F5C60",
    strokeWidth: 1.424,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.855 58.4h9.173V46.36h-9.173V58.4zm0 18.074h9.173v-12.04h-9.173v12.04zm-17.07-18.579h10.119V46.36H44.785v11.536zm0 22.306h10.119V64.168H44.785V80.2zm-5.157.226h38.46V37.108h-38.46v43.319zM96.715 57.895h10.119V46.36H96.715v11.536zm0 17.809h10.119V64.166H96.715v11.537zm-15.6-17.808h10.119V46.358H81.115v11.536zm0 22.305h10.119V64.168H81.115V80.2zm-2.966.226h34.646V37.108H78.149v43.319z",
    stroke: "#5F5C60",
    strokeWidth: 1.424,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5F5C60",
    strokeWidth: 1.424,
    strokeLinejoin: "round",
    d: "M78.15 37.163h38.562l-7.964-25.156H78.15zM39.628 37.163h38.46V12.008h-38.46z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .244)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#5F5C60",
    strokeWidth: 1.424,
    strokeLinejoin: "round",
    d: "M39.742 11.763H8.743L.712 36.92h39.03z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "terraced-icon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#terraced-icon_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#5F5C60",
    strokeWidth: 1.369,
    strokeLinejoin: "round",
    mask: "url(#terraced-icon_svg__b)",
    d: "M3.243 85.315h111.265v-5.026H3.243z"
  })))));
}

export default SvgTerracedIcon;